import { render, staticRenderFns } from "./OrderChart.vue?vue&type=template&id=552a1d21&"
import script from "./OrderChart.vue?vue&type=script&lang=js&"
export * from "./OrderChart.vue?vue&type=script&lang=js&"
import style0 from "./OrderChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports